'use client';

import { mergeClasses } from 'minimal-shared/utils';

import { Box } from '@mui/material';
import Link from '@mui/material/Link';
import { styled, useTheme } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { CONFIG } from 'src/global-config';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export function Logo({ sx, disabled, className, href = '/', isSingle = false, ...other }) {
  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';

  return (
    <LogoRoot
      component={RouterLink}
      href={href}
      aria-label="Logo"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={[
        {
          width: 64,
          height: 64,
          ...(!isSingle && { width: { md: 150, xs: isRtl ? 90 : 120 }, height: 50 }),
          ...(disabled && { pointerEvents: 'none' }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {isSingle ? (
        <Box
          component="img"
          fetchPriority="high"
          priority
          alt="Logo"
          src={
            isRtl
              ? `${CONFIG.assetsDir}/assets/core/shahen-logo-urdu.svg`
              : `${CONFIG.assetsDir}/assets/core/shahen-logo.svg`
          }
        />
      ) : (
        <Box
          component="img"
          alt="Logo"
          fetchPriority="high"
          priority
          src={
            isRtl
              ? `${CONFIG.assetsDir}/assets/core/shahen-logo-urdu.svg`
              : `${CONFIG.assetsDir}/assets/core/shahen-logo.svg`
          }
        />
      )}
    </LogoRoot>
  );
}

// ----------------------------------------------------------------------

const LogoRoot = styled(Link)(() => ({
  flexShrink: 0,
  color: 'inherit',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));
